<template>
  <md-modal-dialog
    class="md-dialog"
    @md-opened="event = 'md-opened'"
    :md-click-outside-to-close="false"
    @md-clicked-outside="onModalClose"
  >
    <ModalWrapper>
      <div class="modal" role="dialog" aria-modal="true" aria-live="assertive" aria-labelledby="heads-up">
        <section class="pilot-ends-modal-wrapper">
          <div class="icon">
            <svg width="9" height="35" viewBox="0 0 4 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 13.2029C0 12.7043 0.192678 12.2819 0.578035 11.9356C0.971098 11.5824 1.44509 11.4058 2 11.4058C2.55491 11.4058 3.02505 11.5824 3.4104 11.9356C3.80347 12.2819 4 12.7043 4 13.2029C4 13.7015 3.80347 14.1274 3.4104 14.4806C3.02505 14.8269 2.55491 15 2 15C1.44509 15 0.971098 14.8269 0.578035 14.4806C0.192678 14.1274 0 13.7015 0 13.2029ZM0 2.17105C0 1.38158 0.196532 0.8241 0.589595 0.498615C0.990366 0.166205 1.4605 0 2 0C2.52408 0 2.98651 0.162742 3.38728 0.488227C3.79576 0.813712 4 1.35042 4 2.09834C4 2.3338 3.93449 2.69044 3.80347 3.16828C3.68015 3.6392 3.45279 4.41482 3.12139 5.49515C2.921 6.14612 2.78227 6.68975 2.7052 7.12604C2.63584 7.5554 2.52023 8.42452 2.35838 9.73338H1.6763C1.45279 8.08518 1.3025 7.06717 1.22543 6.67936C1.14836 6.29155 0.99422 5.74792 0.763006 5.04848C0.470135 4.15512 0.28131 3.55956 0.196532 3.26177C0.0655106 2.79778 0 2.43421 0 2.17105Z"
                fill="#B2B2B2"
              />
            </svg>
          </div>
          <h1 class="heads-up">Heads up!</h1>
          <div class="main-text">
            The AMEX Trips pilot will end on February 28th, 2023. To save the trips you’re working on, consider saving
            them as a PDF
          </div>
          <div class="actions">
            <button class="later-btn" @click="onModalClose">Do Later</button>
            <button class="download-btn" @click="onModalClose">
              <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.96094 5.92146C8.96094 5.63442 9.19359 5.4021 9.48063 5.4021C9.76768 5.4021 10 5.63442 10 5.92146V6.55158C10 7.6398 9.11167 8.52812 8.02379 8.52812H1.97621C0.888328 8.52812 0 7.6398 0 6.55158V5.92146C0 5.63442 0.232322 5.4021 0.519366 5.4021C0.806409 5.4021 1.03906 5.63442 1.03906 5.92146V6.55158C1.03906 7.06636 1.46176 7.48906 1.97621 7.48906H8.02379C8.53824 7.48906 8.96094 7.06636 8.96094 6.55158V5.92146Z"
                  fill="#fff"
                />
                <path
                  d="M4.39623 4.41936L4.39459 0.603906C4.39459 0.270332 4.66492 0 4.99817 0C5.33174 0 5.60208 0.270332 5.60208 0.603906L5.60371 4.41969L6.59264 3.50547C6.83708 3.27938 7.21883 3.29412 7.44492 3.53857C7.67135 3.78301 7.65627 4.16476 7.41183 4.39085L5.41137 6.23992C5.18232 6.4539 4.82385 6.4575 4.59054 6.24156L2.58812 4.39085C2.34367 4.16476 2.3286 3.78301 2.55502 3.53857C2.78112 3.29412 3.16286 3.27938 3.40731 3.50547L4.39623 4.41936Z"
                  fill="#fff"
                />
              </svg>
              Download Trips
            </button>
          </div>
        </section>
      </div>
    </ModalWrapper>
  </md-modal-dialog>
</template>

<script>
import {ModalWrapper} from '@mobi-components/amex-bluesky-components';
import '@mobi-components/amex-bluesky-components/dist/amex-bluesky-components.css';

import Vue from 'vue';
export default Vue.component('pilot-ends-modal', {
  components: {
    ModalWrapper,
  },
  methods: {
    onModalClose() {
      this.$modal.submit(null);
    },
  },
});
</script>

<style scoped>
.pilot-ends-modal-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.md-dialog {
  /* --md-theme-default-primary: var(--primary);
  --md-theme-default-primary-on-background: var(--primary);
  --md-theme-default-accent-on-background: transparent;
  --md-theme-default-text-primary-on-accent: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(221, 217, 217, 0.87)
  ); */
  --max-dialog-width: 480px;
}

.modal {
  max-height: 50vh;
  overflow: auto;
}

.btn-close {
  top: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.3s ease background;
  padding: 20px 20px 11px;
  border-radius: 0 19px 0 20px;
  z-index: 1;
  position: absolute;
  font-size: 14px;
  color: #fff;
  appearance: none;
  border: none;
  cursor: pointer;
}

.main-text {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 118.14%;
  /* or 19px */

  text-align: center;
  letter-spacing: -0.005em;

  color: rgba(7, 29, 59, 0.5);
}
.icon {
  margin: 10px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #f1f1f1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.actions {
  margin-top: 40px;
  display: flex;
  justify-content: space-around;
}

.actions > button {
  appearance: none;
  background: none;
  border-radius: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 118.14%;
  text-align: center;
  letter-spacing: -0.005em;
  cursor: pointer;
  border: none;
  padding: 15px;
}

.actions > button + button {
  margin-left: 10px;
}

.actions > .later-btn {
  color: #878787;
  background: #d3d3d3;
}

.actions > .download-btn {
  color: #fff;
  background: var(--btn-primary-color, #2c70c9);
}
</style>
<style>
.box-wrapper .box {
  padding: 40px;
}
</style>
